let startTimer, endTimer;

export default {
  bind(el) {
    let timeOutInstance = null;

    startTimer = evnt => {
      if (!timeOutInstance) {
        timeOutInstance = setTimeout(() => {
          if (el.contains(evnt.target)) {
            el.dispatchEvent(new Event("hover"));
            timeOutInstance = null;
          }
        }, 100);
      }
    };

    endTimer = () => {
      clearTimeout(timeOutInstance);
      timeOutInstance = null;
    };

    el.addEventListener("mouseenter", startTimer, true);
    el.addEventListener("mouseleave", endTimer, true);
  },

  unbind(el) {
    el.removeEventListener("mouseenter", startTimer, true);
    el.removeEventListener("mouseleave", endTimer, true);
  }
};
